import React from "react";

import ConfirmDialog from "../../../shared/confirm-dialog";
import { useTrainingMigrationContext } from "./context/training-migration-provider";
import { StartEdappMigrationForm } from "./start-edapp-migration-form";

export const StartEdappMigrationDialog: React.FC = () => {
  const {
    edappMigrationDialogOpen,
    setEdappMigrationDialogOpen,
    resetEdappMigrationFormState,
    handleStartEdappMigration,
  } = useTrainingMigrationContext();

  return (
    <ConfirmDialog
      title="Start Edapp Migration"
      open={edappMigrationDialogOpen}
      setOpen={setEdappMigrationDialogOpen}
      onConfirm={async () => {
        handleStartEdappMigration();
      }}
      width="md"
      cancelBtnLabel="Cancel"
      confirmBtnLabel="Start"
      onCancel={() => {
        resetEdappMigrationFormState();
        setEdappMigrationDialogOpen(false);
      }}
    >
      <StartEdappMigrationForm />
    </ConfirmDialog>
  );
};
